import React from "react";
import "./SidebarTabs.css";

// On reçoit le tableau TABS en props depuis App.js
const SidebarTabs = ({ tabs, activeTab, setActiveTab }) => (
  <nav className="sidebar-tabs">
    <ul>
      {tabs.map((tab) => (
        <li key={tab.id}>
          <button
            className={activeTab === tab.id ? "active" : ""}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  </nav>
);

export default SidebarTabs;
